// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../../reason/next/Next.bs.js");
let Sentry = require("../../../reason/Sentry.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let V4 = require("uuid/v4");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");
let RelayRuntime = require("relay-runtime");
let SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let PropertyPriceInput = require("../propertyForms/PropertyPriceInput.bs.js");
let RescriptRelayReact = require("rescript-relay/src/RescriptRelayReact.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let RecordPropertyCreatedEvent = require("../../../reason/clients/graphql/RecordPropertyCreatedEvent.bs.js");
let RentalPropertyAttributesInput = require("../propertyForms/RentalPropertyAttributesInput.bs.js");
let ForSalePropertyAttributesInput = require("../propertyForms/ForSalePropertyAttributesInput.bs.js");
let PropertyWizardFormRelayMutations_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_draft_graphql.bs.js");
let PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.bs.js");
let PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.bs.js");
let PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.bs.js");
let PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.bs.js");
let PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.bs.js");
let PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.bs.js");
let PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.bs.js");

let convertVariables = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Internal.convertVariables;

let convertResponse = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.node, convertResponse, convertWrapRawResponse);

let BroadcastForSalePropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Utils.mlsListingTypeV5_decode;

let BroadcastForSalePropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Utils.mlsListingTypeV5_fromString;

let BroadcastForSalePropertyMutation_showingTypeV5_decode = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Utils.showingTypeV5_decode;

let BroadcastForSalePropertyMutation_showingTypeV5_fromString = PropertyWizardFormRelayMutations_BroadcastForSalePropertyMutation_graphql.Utils.showingTypeV5_fromString;

let BroadcastForSalePropertyMutation = {
  mlsListingTypeV5_decode: BroadcastForSalePropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: BroadcastForSalePropertyMutation_mlsListingTypeV5_fromString,
  showingTypeV5_decode: BroadcastForSalePropertyMutation_showingTypeV5_decode,
  showingTypeV5_fromString: BroadcastForSalePropertyMutation_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertVariables$1 = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Internal.convertVariables;

let convertResponse$1 = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let BroadcastRentalPropertyMutation_leaseLengthValue_decode = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Utils.leaseLengthValue_decode;

let BroadcastRentalPropertyMutation_leaseLengthValue_fromString = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Utils.leaseLengthValue_fromString;

let BroadcastRentalPropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Utils.mlsListingTypeV5_decode;

let BroadcastRentalPropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_BroadcastRentalPropertyMutation_graphql.Utils.mlsListingTypeV5_fromString;

let BroadcastRentalPropertyMutation = {
  leaseLengthValue_decode: BroadcastRentalPropertyMutation_leaseLengthValue_decode,
  leaseLengthValue_fromString: BroadcastRentalPropertyMutation_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: BroadcastRentalPropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: BroadcastRentalPropertyMutation_mlsListingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$1
};

let convertVariables$2 = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Internal.convertVariables;

let convertResponse$2 = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$2 = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$2 = RescriptRelay_Mutation.commitMutation(convertVariables$2, PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables$2, PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let EditForSalePropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Utils.mlsListingTypeV5_decode;

let EditForSalePropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Utils.mlsListingTypeV5_fromString;

let EditForSalePropertyMutation_propertyIdentityTransitionInput_decode = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Utils.propertyIdentityTransitionInput_decode;

let EditForSalePropertyMutation_propertyIdentityTransitionInput_fromString = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Utils.propertyIdentityTransitionInput_fromString;

let EditForSalePropertyMutation_showingTypeV5_decode = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Utils.showingTypeV5_decode;

let EditForSalePropertyMutation_showingTypeV5_fromString = PropertyWizardFormRelayMutations_EditForSalePropertyMutation_graphql.Utils.showingTypeV5_fromString;

let EditForSalePropertyMutation = {
  mlsListingTypeV5_decode: EditForSalePropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: EditForSalePropertyMutation_mlsListingTypeV5_fromString,
  propertyIdentityTransitionInput_decode: EditForSalePropertyMutation_propertyIdentityTransitionInput_decode,
  propertyIdentityTransitionInput_fromString: EditForSalePropertyMutation_propertyIdentityTransitionInput_fromString,
  showingTypeV5_decode: EditForSalePropertyMutation_showingTypeV5_decode,
  showingTypeV5_fromString: EditForSalePropertyMutation_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  commitMutation: commitMutation$2,
  use: use$2
};

let convertVariables$3 = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Internal.convertVariables;

let convertResponse$3 = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$3 = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$3 = RescriptRelay_Mutation.commitMutation(convertVariables$3, PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

let use$3 = RescriptRelay_Mutation.useMutation(convertVariables$3, PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

let EditRentalPropertyMutation_leaseLengthValue_decode = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Utils.leaseLengthValue_decode;

let EditRentalPropertyMutation_leaseLengthValue_fromString = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Utils.leaseLengthValue_fromString;

let EditRentalPropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Utils.mlsListingTypeV5_decode;

let EditRentalPropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_EditRentalPropertyMutation_graphql.Utils.mlsListingTypeV5_fromString;

let EditRentalPropertyMutation = {
  leaseLengthValue_decode: EditRentalPropertyMutation_leaseLengthValue_decode,
  leaseLengthValue_fromString: EditRentalPropertyMutation_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: EditRentalPropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: EditRentalPropertyMutation_mlsListingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$3,
  convertResponse: convertResponse$3,
  convertWrapRawResponse: convertWrapRawResponse$3,
  commitMutation: commitMutation$3,
  use: use$3
};

let convertVariables$4 = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Internal.convertVariables;

let convertResponse$4 = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$4 = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$4 = RescriptRelay_Mutation.commitMutation(convertVariables$4, PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.node, convertResponse$4, convertWrapRawResponse$4);

let use$4 = RescriptRelay_Mutation.useMutation(convertVariables$4, PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.node, convertResponse$4, convertWrapRawResponse$4);

let RebroadcastForSalePropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Utils.mlsListingTypeV5_decode;

let RebroadcastForSalePropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Utils.mlsListingTypeV5_fromString;

let RebroadcastForSalePropertyMutation_propertyIdentityTransitionInput_decode = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Utils.propertyIdentityTransitionInput_decode;

let RebroadcastForSalePropertyMutation_propertyIdentityTransitionInput_fromString = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Utils.propertyIdentityTransitionInput_fromString;

let RebroadcastForSalePropertyMutation_showingTypeV5_decode = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Utils.showingTypeV5_decode;

let RebroadcastForSalePropertyMutation_showingTypeV5_fromString = PropertyWizardFormRelayMutations_RebroadcastForSalePropertyV5Mutation_graphql.Utils.showingTypeV5_fromString;

let RebroadcastForSalePropertyMutation = {
  mlsListingTypeV5_decode: RebroadcastForSalePropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: RebroadcastForSalePropertyMutation_mlsListingTypeV5_fromString,
  propertyIdentityTransitionInput_decode: RebroadcastForSalePropertyMutation_propertyIdentityTransitionInput_decode,
  propertyIdentityTransitionInput_fromString: RebroadcastForSalePropertyMutation_propertyIdentityTransitionInput_fromString,
  showingTypeV5_decode: RebroadcastForSalePropertyMutation_showingTypeV5_decode,
  showingTypeV5_fromString: RebroadcastForSalePropertyMutation_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$4,
  convertResponse: convertResponse$4,
  convertWrapRawResponse: convertWrapRawResponse$4,
  commitMutation: commitMutation$4,
  use: use$4
};

let convertVariables$5 = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Internal.convertVariables;

let convertResponse$5 = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$5 = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$5 = RescriptRelay_Mutation.commitMutation(convertVariables$5, PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.node, convertResponse$5, convertWrapRawResponse$5);

let use$5 = RescriptRelay_Mutation.useMutation(convertVariables$5, PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.node, convertResponse$5, convertWrapRawResponse$5);

let RebroadcastRentalPropertyMutation_leaseLengthValue_decode = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Utils.leaseLengthValue_decode;

let RebroadcastRentalPropertyMutation_leaseLengthValue_fromString = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Utils.leaseLengthValue_fromString;

let RebroadcastRentalPropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Utils.mlsListingTypeV5_decode;

let RebroadcastRentalPropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_RebroadcastRentalPropertyV5Mutation_graphql.Utils.mlsListingTypeV5_fromString;

let RebroadcastRentalPropertyMutation = {
  leaseLengthValue_decode: RebroadcastRentalPropertyMutation_leaseLengthValue_decode,
  leaseLengthValue_fromString: RebroadcastRentalPropertyMutation_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: RebroadcastRentalPropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: RebroadcastRentalPropertyMutation_mlsListingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$5,
  convertResponse: convertResponse$5,
  convertWrapRawResponse: convertWrapRawResponse$5,
  commitMutation: commitMutation$5,
  use: use$5
};

let convertVariables$6 = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Internal.convertVariables;

let convertResponse$6 = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$6 = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$6 = RescriptRelay_Mutation.commitMutation(convertVariables$6, PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.node, convertResponse$6, convertWrapRawResponse$6);

let use$6 = RescriptRelay_Mutation.useMutation(convertVariables$6, PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.node, convertResponse$6, convertWrapRawResponse$6);

let BroadcastQuietPropertyMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Utils.mlsListingTypeV5_decode;

let BroadcastQuietPropertyMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Utils.mlsListingTypeV5_fromString;

let BroadcastQuietPropertyMutation_showingTypeV5_decode = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Utils.showingTypeV5_decode;

let BroadcastQuietPropertyMutation_showingTypeV5_fromString = PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation_graphql.Utils.showingTypeV5_fromString;

let BroadcastQuietPropertyMutation = {
  mlsListingTypeV5_decode: BroadcastQuietPropertyMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: BroadcastQuietPropertyMutation_mlsListingTypeV5_fromString,
  showingTypeV5_decode: BroadcastQuietPropertyMutation_showingTypeV5_decode,
  showingTypeV5_fromString: BroadcastQuietPropertyMutation_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$6,
  convertResponse: convertResponse$6,
  convertWrapRawResponse: convertWrapRawResponse$6,
  commitMutation: commitMutation$6,
  use: use$6
};

let convertFragment = PropertyWizardFormRelayMutations_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayMutations_draft_graphql.node, convertFragment, fRef);
}

function use$7(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayMutations_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayMutations_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayMutations_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelayMutations_draft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let DraftFragment_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelayMutations_draft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let DraftFragment_leaseLengthValue_decode = PropertyWizardFormRelayMutations_draft_graphql.Utils.leaseLengthValue_decode;

let DraftFragment_leaseLengthValue_fromString = PropertyWizardFormRelayMutations_draft_graphql.Utils.leaseLengthValue_fromString;

let DraftFragment_localDraftPropertyType_decode = PropertyWizardFormRelayMutations_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardFormRelayMutations_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment_mlsListingTypeV5_decode = PropertyWizardFormRelayMutations_draft_graphql.Utils.mlsListingTypeV5_decode;

let DraftFragment_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutations_draft_graphql.Utils.mlsListingTypeV5_fromString;

let DraftFragment_rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelayMutations_draft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let DraftFragment_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelayMutations_draft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let DraftFragment_showingTypeV5_decode = PropertyWizardFormRelayMutations_draft_graphql.Utils.showingTypeV5_decode;

let DraftFragment_showingTypeV5_fromString = PropertyWizardFormRelayMutations_draft_graphql.Utils.showingTypeV5_fromString;

let DraftFragment = {
  forSalePropertyTypeEnumV5_decode: DraftFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: DraftFragment_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: DraftFragment_leaseLengthValue_decode,
  leaseLengthValue_fromString: DraftFragment_leaseLengthValue_fromString,
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  mlsListingTypeV5_decode: DraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: DraftFragment_mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: DraftFragment_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: DraftFragment_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: DraftFragment_showingTypeV5_decode,
  showingTypeV5_fromString: DraftFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$7,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function getCommonAttributes(draft) {
  let match = draft.draftProperty;
  let address = match.address;
  if (address !== undefined) {
    let description = match.description;
    if (description !== undefined) {
      let match$1 = match.selectedArea;
      if (match$1 !== undefined) {
        let subject = draft.subject;
        if (subject !== undefined) {
          let message = draft.message;
          let hideAddress = match.hideAddress;
          let files = match.files.map(f => ({
            contentType: f.contentType,
            fileName: f.fileName,
            id: f.id,
            key: f.key
          }));
          let images = match.images.map(f => ({
            contentType: f.contentType,
            fileName: f.fileName,
            id: f.id,
            key: f.key
          }));
          let price = PropertyPriceInput.make(match.priceRange ? "PriceRange" : "ExactPrice", Stdlib_Option.map(match.price, Scalars.PriceInput.fromInt), Stdlib_Option.map(match.minPrice, Scalars.PriceInput.fromInt), Stdlib_Option.map(match.maxPrice, Scalars.PriceInput.fromInt));
          let location_areaId = match$1.id;
          let location = {
            address: address,
            areaId: location_areaId
          };
          return Stdlib_Result.map(price, price => ({
            message: message,
            subject: subject,
            description: description,
            hideAddress: Stdlib_Option.getOr(hideAddress, false),
            images: images,
            files: files,
            price: price,
            location: location
          }));
        }
      }
    }
  }
  if (draft.subject !== undefined) {
    if (address !== undefined) {
      if (match.description !== undefined) {
        return {
          TAG: "Error",
          _0: "missing area"
        };
      } else {
        return {
          TAG: "Error",
          _0: "missing description"
        };
      }
    } else {
      return {
        TAG: "Error",
        _0: "missing address"
      };
    }
  } else {
    return {
      TAG: "Error",
      _0: "missing subject"
    };
  }
}

function getForSaleAttributes(draft) {
  return Stdlib_Result.flatMap(getCommonAttributes(draft), commonAttributes => {
    let match = draft.draftProperty;
    let forSalePropertyType = match.forSalePropertyType;
    let commission = match.commission;
    if (forSalePropertyType === undefined) {
      return {
        TAG: "Error",
        _0: "missing property type"
      };
    }
    let mlsListingType = match.mlsListingType;
    if (mlsListingType === undefined) {
      if (match.mlsListingType !== undefined) {
        return {
          TAG: "Error",
          _0: "attempted to get for-sale attributes on a rental localDraft"
        };
      } else {
        return {
          TAG: "Error",
          _0: "missing mlsListingType"
        };
      }
    }
    if (match.propertyType !== "FOR_SALE") {
      if (match.mlsListingType !== undefined) {
        return {
          TAG: "Error",
          _0: "attempted to get for-sale attributes on a rental localDraft"
        };
      } else {
        return {
          TAG: "Error",
          _0: "missing mlsListingType"
        };
      }
    }
    let showings = Stdlib_Array.keepSome(match.showings).map(f => ({
      date: f.date,
      endTime: f.endTime,
      id: f.id,
      notes: f.notes,
      startTime: f.startTime,
      type: f.type_
    }));
    let tmp;
    switch (forSalePropertyType) {
      case "CONDO" :
        tmp = "Condo";
        break;
      case "LOT" :
        tmp = "Lot";
        break;
      case "MULTI_UNIT" :
        tmp = "MultiUnit";
        break;
      case "SINGLE_FAMILY" :
        tmp = "SingleFamily";
        break;
    }
    let attributes = ForSalePropertyAttributesInput.make(tmp, match.beds, Stdlib_Option.map(match.baths, prim => prim), match.halfBaths, match.lotSize, match.livingArea, match.numberOfUnits, match.parkingSpaces, match.parkingDetails);
    let mlsListing_goingOnMls = match.goingOnMls;
    let mlsListing_onMlsAt = match.onMlsAt;
    let mlsListing_willAcceptOffers = match.willAcceptOffers;
    let mlsListing_willShow = match.willShow;
    let mlsListing = {
      goingOnMls: mlsListing_goingOnMls,
      mlsListingType: mlsListingType,
      onMlsAt: mlsListing_onMlsAt,
      willAcceptOffers: mlsListing_willAcceptOffers,
      willShow: mlsListing_willShow
    };
    return Stdlib_Result.map(attributes, attributes => ({
      message: commonAttributes.message,
      subject: commonAttributes.subject,
      description: commonAttributes.description,
      commission: commission,
      hideAddress: commonAttributes.hideAddress,
      showings: showings,
      images: commonAttributes.images,
      files: commonAttributes.files,
      attributes: attributes,
      price: commonAttributes.price,
      location: commonAttributes.location,
      mlsListing: mlsListing
    }));
  });
}

function getRentalAttributes(draft) {
  return Stdlib_Result.flatMap(getCommonAttributes(draft), commonAttributes => {
    let match = draft.draftProperty;
    let availableFrom = match.availableFrom;
    if (availableFrom !== undefined) {
      let leaseLength = match.leaseLength;
      if (leaseLength !== undefined) {
        let mlsListingType = match.mlsListingType;
        if (mlsListingType !== undefined) {
          let availableFrom$1 = Primitive_option.valFromOption(availableFrom);
          if (match.propertyType !== "FOR_SALE") {
            let rentalPropertyType = match.rentalPropertyType;
            if (rentalPropertyType !== undefined) {
              let attributes = RentalPropertyAttributesInput.make(rentalPropertyType, match.beds, Stdlib_Option.map(match.baths, prim => prim), match.halfBaths, match.lotSize, match.livingArea, match.parkingSpaces, match.parkingDetails);
              let mlsListing_goingOnMls = match.goingOnMls;
              let mlsListing_onMlsAt = match.onMlsAt;
              let mlsListing = {
                goingOnMls: mlsListing_goingOnMls,
                mlsListingType: mlsListingType,
                onMlsAt: mlsListing_onMlsAt
              };
              return Stdlib_Result.map(attributes, attributes => ({
                message: commonAttributes.message,
                subject: commonAttributes.subject,
                description: commonAttributes.description,
                hideAddress: commonAttributes.hideAddress,
                images: commonAttributes.images,
                files: commonAttributes.files,
                attributes: attributes,
                price: commonAttributes.price,
                location: commonAttributes.location,
                mlsListing: mlsListing,
                availableFrom: availableFrom$1,
                leaseLength: leaseLength
              }));
            }
          }
        }
      }
    }
    if (match.rentalPropertyType !== undefined) {
      if (match.mlsListingType !== undefined) {
        if (availableFrom !== undefined) {
          if (match.leaseLength !== undefined) {
            return {
              TAG: "Error",
              _0: "attempted to get rental attributes on a for-sale localDraft"
            };
          } else {
            return {
              TAG: "Error",
              _0: "missing leaseLength"
            };
          }
        } else {
          return {
            TAG: "Error",
            _0: "missing availableFrom"
          };
        }
      } else {
        return {
          TAG: "Error",
          _0: "missing mlsListingType"
        };
      }
    } else {
      return {
        TAG: "Error",
        _0: "missing property type"
      };
    }
  });
}

function useMutationForSubmit(draft) {
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayMutations_draft_graphql.node, convertFragment, draft);
  let anonymousBroadcastPropertiesEnabled = PropertyWizardRelayUtils.useAnonymousBroadcastPropertiesEnabled();
  let match$1 = SystemMessages.useSystemMessages();
  let addMessage = match$1.addMessage;
  let recordPropertyCreatedEvent = RecordPropertyCreatedEvent.useRecordEvent();
  let match$2 = use();
  let broadcastNewForSale = match$2[0];
  let match$3 = use$1();
  let broadcastNewRental = match$3[0];
  let match$4 = use$2();
  let editForSale = match$4[0];
  let match$5 = use$3();
  let editRental = match$5[0];
  let match$6 = use$4();
  let rebroadcastForSale = match$6[0];
  let match$7 = use$5();
  let rebroadcastRental = match$7[0];
  let match$8 = use$6();
  let broadcastQuiet = match$8[0];
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  let invalidateProperty = dataId => {
    RelayRuntime.commitLocalUpdate(environment, store => {
      Stdlib_Option.forEach(Primitive_option.fromNullable(store.get(dataId)), prim => {
        prim.invalidateRecord();
      });
    });
  };
  let router = Next.useRouter();
  let dummyReturn = (err, onError) => [
    param => {
      Sentry.captureErrorMessage(`Tried to submit wizard without sufficient data: ` + err, true, undefined, "PropertyWizardFormRelay__Mutations.res", 507, {
        draft: draft$1
      }, undefined, undefined);
      onError();
    },
    false
  ];
  let onError = () => {
    let tmp;
    if (typeof mode !== "object") {
      tmp = "There was an error while creating your property";
    } else {
      switch (mode.TAG) {
        case "Edit" :
          tmp = "There was an error while saving your changes";
          break;
        case "Rebroadcast" :
          tmp = "There was an error while rebroadcasting your property";
          break;
        case "BroadcastQuietSeller" :
          tmp = "There was an error while broadcasting your property";
          break;
      }
    }
    addMessage(SystemMessages.Message.make(V4(), "error", tmp, 5000, undefined, undefined));
  };
  let displayNeighborhoodId = Stdlib_Option.map(draft$1.draftProperty.displayNeighborhood, d => d.id);
  let commission = draft$1.draftProperty.commission;
  let match$9 = draft$1.draftProperty.anonymousProperty;
  let identityTransition;
  if (typeof mode !== "object") {
    identityTransition = undefined;
  } else {
    switch (mode.TAG) {
      case "Edit" :
      case "Rebroadcast" :
        identityTransition = match$9 ? undefined : "REVEAL_IDENTITY";
        break;
      case "BroadcastQuietSeller" :
        identityTransition = undefined;
        break;
    }
  }
  if (typeof mode !== "object") {
    let match$10 = draft$1.draftProperty.propertyType;
    let match$11 = draft$1.serverDraftId;
    if (match$10 === "FOR_SALE") {
      if (match$11 === undefined) {
        return dummyReturn("missing serverDraftId", onError);
      }
      let forSaleAttributes = getForSaleAttributes(draft$1);
      if (forSaleAttributes.TAG !== "Ok") {
        return dummyReturn(forSaleAttributes._0, onError);
      }
      let forSaleAttributes$1 = forSaleAttributes._0;
      let mutationFn = () => Primitive_option.some(broadcastNewForSale({
        input: {
          anonymousProperty: draft$1.draftProperty.anonymousProperty,
          attributes: forSaleAttributes$1.attributes,
          commission: commission,
          description: forSaleAttributes$1.description,
          displayNeighborhoodId: displayNeighborhoodId,
          draftId: match$11,
          files: forSaleAttributes$1.files,
          hideAddress: forSaleAttributes$1.hideAddress,
          images: forSaleAttributes$1.images,
          location: forSaleAttributes$1.location,
          message: forSaleAttributes$1.message,
          mlsListing: forSaleAttributes$1.mlsListing,
          price: forSaleAttributes$1.price,
          showings: forSaleAttributes$1.showings,
          subject: forSaleAttributes$1.subject,
          website: draft$1.draftProperty.website
        }
      }, undefined, undefined, undefined, (response, mutationErrors) => {
        let match = response.broadcastForSalePropertyV5;
        if (match !== undefined && match.__typename === "ForSalePropertyBroadcasted") {
          let match$1 = match.client;
          if (match$1 !== undefined && mutationErrors === undefined) {
            recordPropertyCreatedEvent(match.property.id);
            addMessage(SystemMessages.Message.make(V4(), "info", "Your property was broadcast to Top Agent Network", 5000, undefined, undefined));
            return Next.Router.push("/my_clients/" + (match$1.id + "?isNew=1"), undefined, undefined, router);
          }
        }
        onError();
        Sentry.captureErrorMessage("Errors broadcasting for-sale property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 597, {
          errors: mutationErrors,
          data: response
        }, undefined, undefined);
      }, e => {
        Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 611, undefined, undefined, undefined);
        onError();
      }, undefined));
      return [
        mutationFn,
        match$2[1]
      ];
    }
    if (match$11 === undefined) {
      return dummyReturn("missing serverDraftId", onError);
    }
    let err = getRentalAttributes(draft$1);
    if (err.TAG !== "Ok") {
      return dummyReturn(err._0, onError);
    }
    let rentalAttributes = err._0;
    let mutationFn$1 = () => Primitive_option.some(broadcastNewRental({
      input: {
        attributes: rentalAttributes.attributes,
        availableFrom: rentalAttributes.availableFrom,
        description: rentalAttributes.description,
        draftId: match$11,
        files: rentalAttributes.files,
        hideAddress: rentalAttributes.hideAddress,
        images: rentalAttributes.images,
        leaseLength: rentalAttributes.leaseLength,
        location: rentalAttributes.location,
        message: rentalAttributes.message,
        mlsListing: rentalAttributes.mlsListing,
        price: rentalAttributes.price,
        subject: rentalAttributes.subject,
        website: draft$1.draftProperty.website
      }
    }, undefined, undefined, undefined, (response, mutationErrors) => {
      let match = response.broadcastRentalPropertyV5;
      if (match !== undefined && match.__typename === "RentalPropertyBroadcasted") {
        let match$1 = match.client;
        if (match$1 !== undefined && mutationErrors === undefined) {
          recordPropertyCreatedEvent(match.property.id);
          addMessage(SystemMessages.Message.make(V4(), "info", "Your property was broadcast to Top Agent Network", 5000, undefined, undefined));
          return Next.Router.push("/my_clients/" + (match$1.id + "?isNew=1"), undefined, undefined, router);
        }
      }
      onError();
      Sentry.captureErrorMessage("Errors broadcasting rental property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 673, {
        errors: mutationErrors,
        data: response
      }, undefined, undefined);
    }, e => {
      Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 687, undefined, undefined, undefined);
      onError();
    }, undefined));
    return [
      mutationFn$1,
      match$3[1]
    ];
  }
  switch (mode.TAG) {
    case "Edit" :
      let id = mode.id;
      let match$12 = draft$1.draftProperty.propertyType;
      if (match$12 === "FOR_SALE") {
        let forSaleAttributes$2 = getForSaleAttributes(draft$1);
        if (forSaleAttributes$2.TAG !== "Ok") {
          return dummyReturn(forSaleAttributes$2._0, onError);
        }
        let forSaleAttributes$3 = forSaleAttributes$2._0;
        let mutationFn$2 = () => Primitive_option.some(editForSale({
          input: {
            attributes: forSaleAttributes$3.attributes,
            commission: commission,
            description: forSaleAttributes$3.description,
            displayNeighborhoodId: displayNeighborhoodId,
            files: forSaleAttributes$3.files,
            hideAddress: forSaleAttributes$3.hideAddress,
            id: id,
            identityTransition: identityTransition,
            images: forSaleAttributes$3.images,
            location: forSaleAttributes$3.location,
            message: forSaleAttributes$3.message,
            mlsListing: forSaleAttributes$3.mlsListing,
            price: forSaleAttributes$3.price,
            showings: forSaleAttributes$3.showings,
            subject: forSaleAttributes$3.subject,
            website: draft$1.draftProperty.website
          }
        }, undefined, undefined, undefined, (response, mutationErrors) => {
          let match = response.editForSaleProperty;
          if (match !== undefined && match.__typename === "ForSalePropertyEdited") {
            let match$1 = match.client;
            if (match$1 !== undefined) {
              let match$2 = match.editableProperty;
              if (match$2 !== undefined) {
                let match$3 = match$2.property;
                if (match$3 !== undefined && mutationErrors === undefined) {
                  addMessage(SystemMessages.Message.make(V4(), "info", "Your property has been updated", 5000, undefined, undefined));
                  invalidateProperty(match$3.__id);
                  return Next.Router.push("/my_clients/" + match$1.id, undefined, undefined, router);
                }
              }
            }
          }
          onError();
          Sentry.captureErrorMessage("Errors editing for-sale property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 753, {
            errors: mutationErrors,
            data: response
          }, undefined, undefined);
        }, e => {
          Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 767, undefined, undefined, undefined);
          onError();
        }, undefined));
        return [
          mutationFn$2,
          match$4[1]
        ];
      }
      let err$1 = getRentalAttributes(draft$1);
      if (err$1.TAG !== "Ok") {
        return dummyReturn(err$1._0, onError);
      }
      let rentalAttributes$1 = err$1._0;
      let mutationFn$3 = () => Primitive_option.some(editRental({
        input: {
          attributes: rentalAttributes$1.attributes,
          availableFrom: rentalAttributes$1.availableFrom,
          description: rentalAttributes$1.description,
          displayNeighborhoodId: displayNeighborhoodId,
          files: rentalAttributes$1.files,
          hideAddress: rentalAttributes$1.hideAddress,
          id: id,
          images: rentalAttributes$1.images,
          leaseLength: rentalAttributes$1.leaseLength,
          location: rentalAttributes$1.location,
          message: rentalAttributes$1.message,
          mlsListing: rentalAttributes$1.mlsListing,
          price: rentalAttributes$1.price,
          subject: rentalAttributes$1.subject,
          website: draft$1.draftProperty.website
        }
      }, undefined, undefined, undefined, (response, mutationErrors) => {
        let match = response.editRentalProperty;
        if (match !== undefined && match.__typename === "RentalPropertyEdited") {
          let match$1 = match.client;
          if (match$1 !== undefined) {
            let match$2 = match.editableProperty;
            if (match$2 !== undefined) {
              let match$3 = match$2.property;
              if (match$3 !== undefined && mutationErrors === undefined) {
                addMessage(SystemMessages.Message.make(V4(), "info", "Your property has been updated", 5000, undefined, undefined));
                invalidateProperty(match$3.__id);
                return Next.Router.push("/my_clients/" + match$1.id, undefined, undefined, router);
              }
            }
          }
        }
        onError();
        Sentry.captureErrorMessage("Errors editing rental property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 829, {
          errors: mutationErrors,
          data: response
        }, undefined, undefined);
      }, e => {
        Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 843, undefined, undefined, undefined);
        onError();
      }, undefined));
      return [
        mutationFn$3,
        match$5[1]
      ];
    case "Rebroadcast" :
      let id$1 = mode._0;
      let match$13 = draft$1.draftProperty.propertyType;
      if (match$13 === "FOR_SALE") {
        let forSaleAttributes$4 = getForSaleAttributes(draft$1);
        if (forSaleAttributes$4.TAG !== "Ok") {
          return dummyReturn(forSaleAttributes$4._0, onError);
        }
        let forSaleAttributes$5 = forSaleAttributes$4._0;
        let mutationFn$4 = () => Primitive_option.some(rebroadcastForSale({
          input: {
            attributes: forSaleAttributes$5.attributes,
            commission: commission,
            description: forSaleAttributes$5.description,
            displayNeighborhoodId: displayNeighborhoodId,
            draftId: draft$1.serverDraftId,
            files: forSaleAttributes$5.files,
            hideAddress: forSaleAttributes$5.hideAddress,
            id: id$1,
            identityTransition: identityTransition,
            images: forSaleAttributes$5.images,
            location: forSaleAttributes$5.location,
            message: Stdlib_Option.getOr(forSaleAttributes$5.message, ""),
            mlsListing: forSaleAttributes$5.mlsListing,
            price: forSaleAttributes$5.price,
            showings: forSaleAttributes$5.showings,
            subject: forSaleAttributes$5.subject,
            website: draft$1.draftProperty.website
          }
        }, undefined, undefined, undefined, (response, mutationErrors) => {
          let match = response.rebroadcastForSalePropertyV5;
          if (match !== undefined && match.__typename === "ForSalePropertyRebroadcasted") {
            let match$1 = match.client;
            if (match$1 !== undefined) {
              let match$2 = match.editableProperty;
              if (match$2 !== undefined) {
                let match$3 = match$2.property;
                if (match$3 !== undefined && mutationErrors === undefined) {
                  addMessage(SystemMessages.Message.make(V4(), "info", "Your property was rebroadcast to Top Agent Network", 5000, undefined, undefined));
                  invalidateProperty(match$3.__id);
                  return Next.Router.push("/my_clients/" + match$1.id, undefined, undefined, router);
                }
              }
            }
          }
          onError();
          Sentry.captureErrorMessage("Errors rebroadcasting for-sale property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 909, {
            errors: mutationErrors,
            data: response
          }, undefined, undefined);
        }, e => {
          Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 923, undefined, undefined, undefined);
          onError();
        }, undefined));
        return [
          mutationFn$4,
          match$6[1]
        ];
      }
      let rentalAttributes$2 = getRentalAttributes(draft$1);
      if (rentalAttributes$2.TAG !== "Ok") {
        return dummyReturn(rentalAttributes$2._0, onError);
      }
      let rentalAttributes$3 = rentalAttributes$2._0;
      let mutationFn$5 = () => Primitive_option.some(rebroadcastRental({
        input: {
          attributes: rentalAttributes$3.attributes,
          availableFrom: rentalAttributes$3.availableFrom,
          description: rentalAttributes$3.description,
          displayNeighborhoodId: displayNeighborhoodId,
          draftId: draft$1.serverDraftId,
          files: rentalAttributes$3.files,
          hideAddress: rentalAttributes$3.hideAddress,
          id: id$1,
          images: rentalAttributes$3.images,
          leaseLength: rentalAttributes$3.leaseLength,
          location: rentalAttributes$3.location,
          message: Stdlib_Option.getOrThrow(rentalAttributes$3.message, undefined),
          mlsListing: rentalAttributes$3.mlsListing,
          price: rentalAttributes$3.price,
          subject: rentalAttributes$3.subject,
          website: draft$1.draftProperty.website
        }
      }, undefined, undefined, undefined, (response, mutationErrors) => {
        let match = response.rebroadcastRentalPropertyV5;
        if (match !== undefined && match.__typename === "RentalPropertyRebroadcasted") {
          let match$1 = match.client;
          if (match$1 !== undefined) {
            let match$2 = match.editableProperty;
            if (match$2 !== undefined) {
              let match$3 = match$2.property;
              if (match$3 !== undefined && mutationErrors === undefined) {
                addMessage(SystemMessages.Message.make(V4(), "info", "Your property has been updated", 5000, undefined, undefined));
                invalidateProperty(match$3.__id);
                return Next.Router.push("/my_clients/" + match$1.id, undefined, undefined, router);
              }
            }
          }
        }
        onError();
        Sentry.captureErrorMessage("Errors rebroadcasting rental property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 986, {
          errors: mutationErrors,
          data: response
        }, undefined, undefined);
      }, e => {
        Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 1000, undefined, undefined, undefined);
        onError();
      }, undefined));
      return [
        mutationFn$5,
        match$7[1]
      ];
    case "BroadcastQuietSeller" :
      let id$2 = mode._0;
      let forSaleAttributes$6 = getForSaleAttributes(draft$1);
      if (forSaleAttributes$6.TAG !== "Ok") {
        return dummyReturn(forSaleAttributes$6._0, onError);
      }
      let forSaleAttributes$7 = forSaleAttributes$6._0;
      let mutationFn$6 = () => Primitive_option.some(broadcastQuiet({
        input: {
          anonymousProperty: anonymousBroadcastPropertiesEnabled ? draft$1.draftProperty.anonymousProperty : false,
          attributes: forSaleAttributes$7.attributes,
          commission: commission,
          description: forSaleAttributes$7.description,
          displayNeighborhoodId: displayNeighborhoodId,
          draftId: draft$1.serverDraftId,
          files: forSaleAttributes$7.files,
          hideAddress: forSaleAttributes$7.hideAddress,
          id: id$2,
          images: forSaleAttributes$7.images,
          location: forSaleAttributes$7.location,
          message: forSaleAttributes$7.message,
          mlsListing: forSaleAttributes$7.mlsListing,
          price: forSaleAttributes$7.price,
          showings: forSaleAttributes$7.showings,
          subject: forSaleAttributes$7.subject,
          website: draft$1.draftProperty.website
        }
      }, undefined, undefined, undefined, (response, mutationErrors) => {
        let match = response.broadcastQuietPropertyV5;
        if (match !== undefined && match.__typename === "QuietPropertyBroadcasted") {
          let match$1 = match.client;
          if (match$1 !== undefined) {
            let match$2 = match.editableProperty;
            if (match$2 !== undefined) {
              let match$3 = match$2.property;
              if (match$3 !== undefined && mutationErrors === undefined) {
                addMessage(SystemMessages.Message.make(V4(), "info", "Your property was broadcast to Top Agent Network", 5000, undefined, undefined));
                invalidateProperty(match$3.__id);
                return Next.Router.push("/my_clients/" + match$1.id, undefined, undefined, router);
              }
            }
          }
        }
        onError();
        Sentry.captureErrorMessage("Errors broadcasting quiet property", true, undefined, "PropertyWizardFormRelay__Mutations.res", 1069, {
          errors: mutationErrors,
          data: response
        }, undefined, undefined);
      }, e => {
        Sentry.captureErrorMessage(e, true, undefined, "PropertyWizardFormRelay__Mutations.res", 1083, undefined, undefined, undefined);
        onError();
      }, undefined));
      return [
        mutationFn$6,
        match$8[1]
      ];
  }
}

exports.BroadcastForSalePropertyMutation = BroadcastForSalePropertyMutation;
exports.BroadcastRentalPropertyMutation = BroadcastRentalPropertyMutation;
exports.EditForSalePropertyMutation = EditForSalePropertyMutation;
exports.EditRentalPropertyMutation = EditRentalPropertyMutation;
exports.RebroadcastForSalePropertyMutation = RebroadcastForSalePropertyMutation;
exports.RebroadcastRentalPropertyMutation = RebroadcastRentalPropertyMutation;
exports.BroadcastQuietPropertyMutation = BroadcastQuietPropertyMutation;
exports.DraftFragment = DraftFragment;
exports.getCommonAttributes = getCommonAttributes;
exports.getForSaleAttributes = getForSaleAttributes;
exports.getRentalAttributes = getRentalAttributes;
exports.useMutationForSubmit = useMutationForSubmit;
/* commitMutation Not a pure module */
